import MyHomePM from './MyHomePM';

// /pm-home (registry label "My Home"). Used to be a role router splitting
// between MyHomePM and MyHomeSupplier — retired 2026-08-31 when the supplier
// experience unified into SupplierPortal.js (one page, four sections: Your
// Tasks, Assigned Programs & Lead Status, Upload a Delivery, Delivery
// History) instead of a separate My Home for that role. `partner` no longer
// carries 'pm-home' in canAccess() (UserContext.js), so this component is
// only ever reached by program_manager/supporting_program_manager/admin now
// — kept as a thin wrapper (rather than pointing App.js's route straight at
// MyHomePM) so a future role split here is a one-line change again if one's
// ever needed.
export default function MyHome() {
  return <MyHomePM />;
}
